import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

interface ResponsiveTableContainerProps extends BoxProps {
  children: React.ReactNode;
}

/** Envuelve tablas con scroll horizontal en pantallas estrechas. */
export const ResponsiveTableContainer: React.FC<ResponsiveTableContainerProps> = ({
  children,
  ...props
}) => (
  <Box
    overflowX="auto"
    maxW="100%"
    sx={{
      WebkitOverflowScrolling: 'touch',
      '& table': { minW: 'max-content' },
    }}
    {...props}
  >
    {children}
  </Box>
);
